<ui-dialog
    #editFormBasicInformation
    formDialog
    size="small"
    header="{{ 'applicant-tracker.applicants.editApplicantDetails' | translate }}"
    [form]="editFormBasicInformationForm.form"
    (primaryButtonPressed)="onSave(editFormBasicInformation.form)"
    [open]="isApplicantEditModalOpen"
    (secondaryButtonPressed)="onCancelApplicantEdit()"
    (closing)="onCancelApplicantEdit()"
>
    <app-applicant-update-basic-information #editFormBasicInformationForm [applicant]="applicant">
    </app-applicant-update-basic-information>
</ui-dialog>

<ui-dialog
    [open]="isApplicantDocumentDeleteModalOpen"
    (closing)="onCancelDeleteApplicantAttachment()"
    header="{{ 'applicant-tracker.applicants.deleteApplicantDocument' | translate }}"
>
    <p>{{ 'applicant-tracker.applicants.areYouSureYouWantToDeleteThisDocument' | translate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="onCancelDeleteApplicantAttachment()">{{
            'applicant-tracker.applicants.cancel' | translate
        }}</ui-button>
        <ui-button type="danger" (click)="onDeleteApplicantAttachment()">{{
            'applicant-tracker.applicants.delete' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    [open]="isAddAdditionalDocumentModalOpen"
    header="{{ 'applicant-tracker.applicants.uploadDocument' | translate }}"
    (closing)="closeAddAdditionalDocumentModal()"
>
    <form #form="ngForm" autocomplete="off">
        <app-file-drop
            (filesSelected)="onDocumentSelected($event)"
            [allowedTypes]="allowedFileTypes"
            [required]="true"
            *ngIf="!applicantDocument"
        ></app-file-drop>

        <mat-label class="uploaded-document margin-bottom-2 padding-1 form-label" *ngIf="applicantDocument">
            <img appIcon="Paperclip" class="margin-right-1" />
            <span class="margin-right-1">{{ applicantDocument.name }}</span>
            <img (click)="resetSelectedDocument()" appIcon="CrossGreyUiOutline" />
        </mat-label>

        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label>{{ 'applicant-tracker.applicants.documentDisplayName' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    name="applicantDocumentDisplayName"
                    [(ngModel)]="applicantDocumentDisplayName"
                />
            </mat-form-field>
        </div>

        <ui-dialog-footer>
            <ui-button type="ghost" (click)="closeAddAdditionalDocumentModal(); resetSelectedDocument()"
                >{{ 'applicant-tracker.applicants.cancel' | translate }}
            </ui-button>
            <ui-button
                type="primary"
                [disabled]="!applicantDocumentDisplayName || !applicantDocument"
                (click)="saveApplicantDocument()"
                >{{ 'applicant-tracker.applicants.add' | translate }}</ui-button
            >
        </ui-dialog-footer>
    </form>
</ui-dialog>

<div class="profile-layout reverse">
    <div class="profile-layout-content">
        <app-applicant-basic-information [applicant]="applicant" (editClicked)="openApplicantEditModal()">
        </app-applicant-basic-information>

        <app-applicant-hiring-details *ngIf="applicant?.isHired" [applicant]="applicant"></app-applicant-hiring-details>

        <ui-card [loading]="isLoading" data-cy="applicant-document">
            <app-segment-header [title]="'applicant-tracker.applicants.applicationDocuments'">
                <ui-info
                    [matTooltipClass]="'allow-multi-line-tooltip'"
                    class="applicant-documents-tooltip"
                    [text]="applicantDocumentToolTip()"
                ></ui-info>
                <div class="buttons">
                    <ui-button
                        (click)="showAddAdditionalDocumentModal()"
                        class="margin-right-2"
                        type="outline"
                        [disabled]="noOfApplicantDocumentsWithoutJobAttachment >= 5"
                    >
                        <mat-icon svgIcon="plus"></mat-icon
                        >{{ 'applicant-tracker.applicants.additionalDocument' | translate }}
                    </ui-button>
                </div>
            </app-segment-header>
            <ng-container *ngIf="uploadAttachments.length">
                <form #uploadForm="ngForm" autocomplete="off">
                    <ng-container *ngFor="let uploadAttachment of uploadAttachments; let i = index; let first = first">
                        <ng-container *ngIf="uploadAttachment.fileId">
                            <mat-expansion-panel
                                [expanded]="pdfPreviewersStates[i]?.panelState"
                                (opened)="onExpansion(true, i); previewDocument(uploadAttachment, pdfPreviewer, i)"
                                (closed)="onExpansion(false, i)"
                                [disabled]="buttonClick"
                                (click)="buttonClick = false"
                                class="app-grid centered"
                            >
                                <mat-expansion-panel-header class="padding-left-2">
                                    <mat-panel-title>
                                        {{
                                            uploadAttachment.jobAttachment?.name ||
                                                uploadAttachment.name ||
                                                'Applicant
                                        Document'
                                        }}
                                    </mat-panel-title>
                                    <mat-panel-description>
                                        <ui-button (click)="preventExpansion()" [matMenu]="meatball">
                                            <mat-icon svgIcon="meatballHorizontal"></mat-icon>
                                        </ui-button>
                                        <!-- Mat menu -->
                                        <mat-menu #meatball xPosition="before">
                                            <button
                                                mat-menu-item
                                                (click)="onClickDeleteApplicantAttachment(uploadAttachment)"
                                            >
                                                {{ 'applicant-tracker.applicants.delete' | translate }}
                                            </button>
                                            <button mat-menu-item (click)="downloadFile(uploadAttachment)">
                                                {{ 'applicant-tracker.applicants.download' | translate }}
                                            </button>
                                        </mat-menu>
                                    </mat-panel-description>
                                    <ui-button type="ghost">
                                        {{ (pdfPreviewersStates[i]?.panelState ? 'collapse' : 'show') | translate }}
                                    </ui-button>
                                </mat-expansion-panel-header>
                                <div>
                                    <app-pdf-viewer [static]="false" #pdfPreviewer></app-pdf-viewer>
                                    <div
                                        *ngIf="pdfPreviewersStates[i]?.pdfPreviewableError"
                                        class="pdf-previewer-error"
                                    >
                                        <p>{{ 'applicant-tracker.applicants.noPreviewAvailable' | translate }}</p>
                                    </div>
                                    <div *ngIf="pdfPreviewersStates[i]?.pdfError" class="pdf-previewer-error">
                                        <p>
                                            {{
                                                'applicant-tracker.applicants.theSystemWasNotAbleToDisplayThisFileTypePleaseDownloadThedocumen'
                                                    | translate
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        </ng-container>
                        <ng-container *ngIf="!uploadAttachment.fileId">
                            <div class="app-grid centered">
                                <mat-form-field class="columns-4" [class.margin-top-3]="!first">
                                    <mat-label>
                                        {{
                                            'applicant-tracker.uploadJobAttachmentName'
                                                | translate: { jobAttachmentName: uploadAttachment.jobAttachment?.name }
                                        }}
                                    </mat-label>
                                    <ui-mat-file-upload
                                        (fileSelected)="onFileUpload($event, uploadAttachment)"
                                        placeholder="{{ 'applicant-tracker.applicants.noFileAttached' | translate }}"
                                        [allowedTypes]="allowedFileTypes"
                                    >
                                    </ui-mat-file-upload>
                                    <ui-button type="outline">{{
                                        'applicant-tracker.applicants.browse' | translate
                                    }}</ui-button>
                                </mat-form-field>
                            </div>
                        </ng-container>
                    </ng-container>
                </form>
            </ng-container>
            <ng-container *ngIf="!uploadAttachments.length">
                <h4>{{ 'applicant-tracker.applicants.noDocuments' | translate }}</h4>
            </ng-container>
        </ui-card>
    </div>
    <div class="profile-layout-sidebar">
        <app-job-postings-card *ngIf="applicant" [applicant]="applicant"></app-job-postings-card>
        <app-application-information-card
            *ngIf="applicant"
            [applicationInformation]="{ createdAt: applicant.createdAt, source: applicant.applicationSource }"
        >
        </app-application-information-card>
        <app-comments-mini></app-comments-mini>
    </div>
</div>
